import { render, staticRenderFns } from "./RepairItemForm.vue?vue&type=template&id=67dd865b"
import script from "./RepairItemForm.vue?vue&type=script&lang=js"
export * from "./RepairItemForm.vue?vue&type=script&lang=js"
import style0 from "./RepairItemForm.vue?vue&type=style&index=0&id=67dd865b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports